
<template>
  <div class="addTurnPond">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">转塘记录单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter" :disabled="enableTable||!edit">修改</el-button>
            <el-button size="small" class="save" @click="onSave" :disabled="!enableTable||!edit" :loading="isLoading">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="closeView">关闭</el-button>
          </div>
          <div class="custom-search-container" style="margin-top:15px;">
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>转出基地</span>
                <el-select v-model="order.outFishBaseId" :disabled="Boolean(orderId)||!edit" filterable placeholder="请选择" size="small" @change="baseChange">
                  <el-option v-for="(item, index) in baseListOut" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
            <div class="custom-search-box-warpper" style="margin-left:8px;">
                <span>日期</span>
                <el-date-picker size="small" v-model="order.date" type="date" :disabled="!edit" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
              <div  class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input placeholder="请输入单据号" v-model="order.billsNo" size="small" disabled>
                </el-input>
              </div>
            </div>    
            <div class="custom-search-box">
              <div class="custom-search-box-warpper" v-if="show">
                <span>流水号</span>
                <el-input placeholder="请输入流水号" v-model="order.numericalOrder" size="small" disabled>
                </el-input>
              </div>
                <div class="custom-search-box-warpper">
                <span>转入基地</span>
                <el-select v-model="order.inFishBaseId" :disabled="Boolean(orderId)||!edit" filterable placeholder="请选择" size="small" @change="baseChanges">
                  <el-option v-for="(item, index) in baseListInt" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
              
            </div>  
          </div>
        </div>
      </div>
     
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&Boolean(edit)">
          <thead-ex>
            <th-ex>转出塘口</th-ex>
            <th-ex>转出周期</th-ex>
            <th-ex>品种</th-ex>
            <th-ex>规格单位</th-ex>
            <!-- <th-ex>养殖天数</th-ex> -->
            <th-ex>转入塘口</th-ex>
            <th-ex>转入周期</th-ex>
            <th-ex tip="规格单位为斤/尾时，请填写均重；当单位为尾/斤和万尾时，请填写规格" class="long-tds">均重(规格)</th-ex>
            <th-ex>重量(斤)</th-ex>
            <th-ex>数量</th-ex>
            <th-ex tip="单价为当前市场价，当重量为0，单价以数量为计价单价；当重量不为0，单价为以重量计价单价" >市场价</th-ex>
            <th-ex tip="金额默认=重量*单价；当重量为0，则金额=数量*单价" class="long-tds">金额(元)</th-ex>
            <th-ex tip="用于填写折扣金额，-负数代表减少结算金额，+代表增加结算金额" class="long-tds">调整金额(元)</th-ex>
            <th-ex class="long-tds">结算金额(元)</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <td-ex v-model="item.outFishPondId" :editable="item.pondEdit" :list="fishPondList" display="value" take="key" type='cmb' @selected="pondChangeOut(item)"></td-ex>
              <td-ex v-model="item.outFishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex v-model="item.fishId" :editable="item.fishEdit" type='cmb' :list="item.fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <!-- <td-ex v-model="item.unit" type='input'   onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" ></td-ex> -->
              <td-ex v-model="item.specType"  class="long-td" type='cmb' :list="measurementList" display="name" take="id"  @selected="measureChange(item,index)"></td-ex>
              <!-- <td-ex v-model="item.cultivationDays" type='text' onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" ></td-ex>               -->
              <td-ex v-model="item.inFishPondId" :editable="item.pondEdit" :list="fishPondListIn" display="value" take="key" type='cmb' @selected="pondChangeIn(item)"></td-ex>
              <td-ex v-model="item.inFishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex v-model="item.avgWeight" type='number'  number @input="setQuantityAmount(item)" positive :decimalLength="4"></td-ex>
              <td-ex v-model="item.weight" type='number'  number @input="setMoneyAmount(item)|| setQuantityAmount(item)||setAvgWeightAmount(item)" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.quantity" :type='item.genre'  number @input="setMoneyAmount(item)||setAvgWeightAmount(item)" positive ></td-ex>
              <td-ex v-model="item.unitPriceTax" type='number'  number @input="setMoneyAmount(item)" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.amountTotal" type='text'  @input="setFinalAmount(item)" number></td-ex>
              <td-ex v-model="item.amountAdjust" type='number'  @input="setFinalAmount(item)" number  :decimalLength="2"></td-ex>
              <td-ex v-model="item.finalAmount" type='text'  number></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <!-- <td>--</td> -->
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>{{total('weight')}}</td>
            <td>{{total('quantity')}}</td>
            <td>--</td>
            <td>{{total('amountTotal')}}</td>
            <td>{{total('amountAdjust')}}</td>
            <td>{{total('finalAmount')}}</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import checkPermission from "../../../service/checkPermission.js";
export default {
  mixins: [mixins],
  name: "addTurnPond",
  data() {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      addBaseList: true,
      editBaseList: false,
      show: false,
      delBtnDisable: true,
      addBtnDisable: true,
      alterBtnDisable: true,
      saveBtnDisable: false,
      rollBackBtnDisable: false,
      closeBtnDisable: false,
      orderId: this.$route.query.id,
      order: {
        inFishBaseId: null, //转入基地
        outFishBaseId: null, //转出基地
        date: new Date(),
        numericalOrder: 0,
        billsNo: 0,
        remark: "",
        details: []
      },
      pondList: [],
      baseListOut: [], //转出基地
      baseListInt: [], //转入基地
      fishPondListIn: [], //转入塘口
      fishPondList: [], //转出塘口
      enableTable: false,
      selectedRow: null,
      emptyRow: {
        fishId: null, //渔种Id
        fishName: "", //渔种名称
        inFishPondId: null, //转入塘口
        outFishPondId: null, //转出塘口
        inFishBatchId: null, //转入周期Id
        outFishBatchId: null, //转出周期Id
        inFishBatch: null, //转入周期
        outFishBatch: null, //转出周期
        cultivationDays: null,
        unit: "", //计量单位
        weight: 0, //重量
        avgWeight: 0, //均重
        quantity: 0, //数量
        unitPriceTax: 0, //市场价
        amountTotal: 0, //金额
        amountAdjust: 0, //调整金额
        finalAmount: 0, //结算金额
        fishList: [],
        genre: "text",
        algorithm: "",
        specType: ""
      },
      isLoading: false,
    };
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑转塘管理" : "查看转塘管理";
    } else {
      document.title = "增加转塘管理";
    }
    this.measurementList = await this.getCultureBreed(); //计量单位
    let baseList = await this.getBaseList(); //基地
    this.baseListInt = baseList; //转入基地列表
    this.baseListOut = baseList; //转出基地列表
    this.initData();
  },

  methods: {
    ...mapActions(modules.turnPond, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      addTurnPond: "addTurnPond", //添加
      updateTurnPond: "updateTurnPond", //修改
      getEditTurnPondData: "getEditTurnPondData", //编辑--获取行数据
      delTurnPondList: "delTurnPondList" //删除
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch" //周期
    }),
    ...mapActions(modules.fish, {
      getPondFishList: "getPondFishList" //塘口下的渔种
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber" //流水号
    }),
    ...mapActions(modules.dataDict, [
      "getCultureBreed" //获取养殖品种
    ]),
    ...mapActions(['delVisitedViews']),
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total.toFixed(2);
      // 当单位为万尾，*10000
      // this.order.details.forEach(item => {
      //   console.log(item[prop]);
      //   if (prop == "quantity" && item.specType == 14002) {
      //     total += Number(item[prop]) * 10000;
      //     console.log(total);
      //   } else {
      //     total += Number(item[prop]);
      //   }
      // });
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        //新增
        this.order.numericalOrder = await this.getSerialNumber();
        this.initTable();
      } else {
        //修改
        let result = await this.getEditTurnPondData(this.orderId);
        this.order.inFishBaseId = result.inFishBaseId;
        this.order.outFishBaseId = result.outFishBaseId;
        await this.baseChange(result.outFishBaseId, true);
        await this.baseChanges(result.inFishBaseId, true);
        var promises = result.details.map(item =>
          (async () => {
            item.pondEdit = false;
            item.fishEdit = false;
            item.fishList = await this.getPondFishList(item.outFishBatchId);
            let az = item.fishList.find(f => f.id == item.fishId);
            if (az) {
              item.fishName = az.name;
              item.unit = az.unitName;
            }
            this.setMoneyAmount(item);
            this.setFinalAmount(item);
            //this.setQuantityAmount(item);
            this.setAvgWeightAmount(item);
            item.cultivationDays = item.cultivationDays.toFixed(0);
          })()
        );
        await Promise.all(promises);
        this.order = result;
        this.orderId = result.orderId;
      }
      this.enableTable = true;
    },
    //转出-----改变基地数据
    async baseChange(e, notShowTip) {
      let selectedBase = this.baseListOut.find(f => f.key == e);
      if (!notShowTip && selectedBase && !selectedBase.notCleard) {
        this.$Alert.info({
          content: "当前选择的基地已经全部清塘，请选择其他基地",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地已经全部清塘，请选择其他基地");
      }
      let fishPondList = await this.getFishPond(e);
      this.fishPondList = fishPondList;
      this.enableTable = true;
      this.order.details.forEach(f => {
        f.outFishPondId = null;
        f.outFishBatchId = null;
        f.outFishBatch = null;
        f.cultivationDays = null;
      });
    },
    //转入改变基地数据
    async baseChanges(e) {
      let fishPondListIn = await this.getFishPond(e);
      this.fishPondListIn = fishPondListIn;
      if (this.fishPondListIn.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下无塘口，请先添加塘口信息",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地下无塘口，请先添加塘口信息");
      }
      this.enableTable = true;
      this.order.details.forEach(f => {
        f.inFishPondId = null;
        f.inFishBatchId = null;
        f.inFishBatch = null;
      });
    },
    //改变塘口--联动周期---转入塘口
    async pondChangeIn(row) {
      if (!row.inFishPondId) {
        //当什么都没有选中，则清理
        row.inFishBatchId = null;
        row.inFishBatch = null;
        return;
      }
      let result = await this.getPondUnclearedBatchNo(row.inFishPondId);
      if (result) {
        row.inFishBatchId = result.key;
        row.inFishBatch = result.value;
      } else {
        try {
          await MessageBox.confirm(
            "此塘口已清塘，是否开启新的养殖周期？",
            "提示"
          );
          try {
            await this.addFishBatch({
              fishPondId: row.inFishPondId,
              batch: 0,
              startDate: this.order.date
            });
            let newBatch = await this.getPondUnclearedBatchNo(row.inFishPondId);
            row.inFishBatchId = newBatch.key;
            row.inFishBatch = newBatch.value;
          } catch (error) {
            row.inFishPondId = null;
            this.$Alert.info({
              content: "开启新周期失败",
              duration: 5000,
              status: "error"
            });
            // Message.error("开启新周期失败");
          }
        } catch (error) {
          row.inFishPondId = null;
        }
      }
    },
    //改变塘口--联动周期---转出塘口
    async pondChangeOut(row) {
      console.log(row);
      if (!row.outFishPondId) {
        //当什么都没有选中，则清理
        row.outFishBatchId = null;
        row.outFishBatch = null;
        return;
      }

      let result = await this.getPondUnclearedBatchNo(row.outFishPondId);
      if (result) {
        row.outFishBatchId = result.key;
        row.outFishBatch = result.value;
        row.fishId = null;
        row.unit = null;
        row.fishName = null;
        console.log(result.key);
        row.fishList = await this.getPondFishList(result.key);
        row.fishList = await this.getPondFishList(result.key);

        if (row.fishList.length == 0) {
          this.$Alert.info({
            content: "此塘口当前周期无进苗数据",
            duration: 5000,
            status: "error"
          });
        }
        // Message.error("此塘口当前周期无进苗数据");
        var date1 = new Date().getTime(); //当前时间
        var date2 = result.startBatchDate;
        var dates = new Date(date2).getTime(); //开塘日期
        if (date1 > dates) {
          row.cultivationDays = (
            (date1 - dates) /
            (1000 * 60 * 60 * 24)
          ).toFixed(0); //计算养殖天数
        }
      } else {
        try {
          await MessageBox.confirm(" 此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
        } catch (error) {
          row.outFishPondId = null;
        }
      }
    },
    fishChange(row) {
      console.log(row);
      let item = row.fishList.find(f => f.id == row.fishId);
      if (item) {
        row.fishName = item.name;
        row.unit = item.unitName;
      }
    },
    measureChange(e, index) {
      if (e.specType == 14000) {
        e.weight = "";
        e.avgWeight = "";
        e.quantity = "";
        e.unitPriceTax = "";
        e.amountTotal = "";
        e.amountAdjust = 0;
        e.finalAmount = "";
        this.order.details[index].genre = "text";
        this.order.details[index].algorithm = "1";
      } else if (e.specType == 14001) {
        e.weight = "";
        e.avgWeight = "";
        e.quantity = "";
        e.unitPriceTax = "";
        e.amountTotal = "";
        e.amountAdjust = 0;
        e.finalAmount = "";
        this.order.details[index].genre = "text";
        this.order.details[index].algorithm = "2";
      } else if (e.specType == 14002) {
        e.weight = "";
        e.avgWeight = "";
        e.quantity = "";
        e.unitPriceTax = "";
        e.amountTotal = "";
        e.amountAdjust = 0;
        e.finalAmount = "";
        this.order.details[index].genre = "input";
        this.order.details[index].algorithm = "3";
        console.log(this.order.details);
      } else if (e.specType == 14003) {
        e.weight = "";
        e.avgWeight = "";
        e.quantity = "";
        e.unitPriceTax = "";
        e.amountTotal = "";
        e.amountAdjust = 0;
        e.finalAmount = "";
        this.order.details[index].genre = "input";
        this.order.details[index].algorithm = "4";
        console.log(this.order.details);
      }
    },
    //保存
    async onSave() {
      this.isLoading = true
      let err = null;
      if (!this.order.inFishBaseId) err = "转入基地必须选择";
      if (!this.order.outFishBaseId) err = "转出基地必须选择";
      if (!this.order.date) err = "日期必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = this.order.details.filter(f => {
        return f.outFishPondId !== "" && f.outFishPondId !== null;
      });
      let weightReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //重量
      let avgWeightReg = /^[0-9]{1,6}([.][0-9]{1,4})?$/; //均重
      // let quantityReg = /^[0-9]{1,12}$/; //数量
      let unitPriceTaxReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //单价
      let amountAdjustReg = /^-?[0-9]{1,12}([.][0-9]{1,2})?$/; //调整金额
      if (list.length == 0) err = "不能提交空表单";
      list.forEach(item => {
        if (item.unitPriceTax === 0) {
          err = "请输入市场价";
        }
        if (item.quantity === 0) {
          err = "请输入数量";
        }
        if (!weightReg.test(item.weight)) {
          err = "重量范围至多12位正整数,2位小数";
        }
        if (!avgWeightReg.test(item.avgWeight)) {
          err = "均重范围位0~999999.0,4位小数";
        }
        if (!unitPriceTaxReg.test(item.unitPriceTax)) {
          err = "单价范围至多12位正整数,2位小数";
        }
        // if (!quantityReg.test(item.quantity)) {
        //   err = "数量只允许输入整数";
        // }
        if (!amountAdjustReg.test(item.amountAdjust)) {
          err = "调整金额范围至多12位整数,2位小数";
        }
        if (!item.inFishPondId) err = "转入塘口必须选择";
        if (!item.outFishPondId) err = "转出塘口必须选择";
        if (!item.outFishBatch || !item.outFishBatchId)
          err = "转出周期必须选择";
        if (!item.inFishBatch || !item.inFishBatchId)
          err = "转入周期批次必须选择";
        if (!item.fishId) {
          err = "品种必须选择";
        }
      });

      if (err) {
        Message.error(err);
        this.isLoading = false
        return;
      }

      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            let result = await this.updateTurnPond({
              id: this.orderId,
              data: this.filterOrder(this.order)
            });
            this.isLoading = false
            this.order.billsNo = result.number;
            this.orderId = result.id;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            let result = await this.addTurnPond(this.filterOrder(this.order));
            this.isLoading = false
            this.orderId = result.ild;
            this.order.billsNo = result.number;
            this.order.numericalOrder = result.numericalOrder;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          this.enableTable = false;
        } catch (error) {
         this.isLoading = false
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(error.response.data);
        }
      });
    },
    // 当单位为万尾时，转换乘以10000
    filterOrder(arr) {
      let datalist = JSON.parse(JSON.stringify(arr));
      let detail = datalist.details.map(item => {
        if (item.specType == 14002) {
          item.quantity = item.quantity * 10000;
        }
        return item;
      });
      console.log(detail);
      datalist.details = detail;
      return datalist;
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach(item => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete() {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error"
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delTurnPondList(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    },
    setFinalAmount(item) {
      item.finalAmount = Number(
        (Number(item.amountTotal) + Number(item.amountAdjust)).toFixed(2)
      );
      this.$forceUpdate()
    },
    setMoneyAmount(item) {
      if (item.weight !== 0) {
        item.amountTotal = Number(
          (Number(item.weight) * Number(item.unitPriceTax)).toFixed(2)
        );
        item.finalAmount = Number(
          (Number(item.amountTotal) + Number(item.amountAdjust)).toFixed(2)
        );
      } else if (item.weight === 0) {
        item.amountTotal = Number(
          (Number(item.quantity) * Number(item.unitPriceTax)).toFixed(2)
        );
        item.finalAmount = Number(
          (Number(item.amountTotal) + Number(item.amountAdjust)).toFixed(2)
        );
      }
    },
    setQuantityAmount(item) {
      if (item.specType == 14000) {
        item.algorithm = "1";
      }
      if (item.specType == 14001) {
        item.algorithm = "2";
      }
      if (item.specType == 14002) {
        item.algorithm = "3";
      }
      if (item.specType == 14003) {
        item.algorithm = "4";
      }
      if (item.avgWeight !== 0) {
        switch (item.algorithm) {
          case "1":
            item.quantity = Math.ceil(
              Number(item.weight) / Number(item.avgWeight)
            );
            break;
          case "2":
            item.quantity = Math.ceil(
              Number(item.weight) * Number(item.avgWeight)
            );
            break;
          case "3":
            item.quantity = item.quantity;
            break;
          case "4":
            item.quantity = item.quantity;
            break;
          default:
            return false;
        }
        return true
      }
    },
    setAvgWeightAmount(item) {
      // if (item.quantity !== 0) {
      //   item.avgWeight = Number(
      //     (Number(item.weight) / Number(item.quantity)).toFixed(2)
      //   );
      // }
      console.log(1);
    },
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/productionControl/turnPondManagement')
    }
  }
};
</script>
<style>
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
.long-tds {
  min-width: 100px;
}
.readonlys input {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
